const LineOfInquiryFunzionariStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Aggiungi/Modifica/Rimuovi Funzionari",
                id: "loiFunzionariForm",
                description: "",
                multipleValue: false,
                rows : [
                {
                    id : "row1",
                    fields : [
                        {
                            name: "funzionariList",
                            type: "choice",
                            numColMd: 6,
                            label: "Funzionario",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                        },
                        {
                            name: "ruoloList",
                            type: "choice",
                            numColMd: 4,
                            label: "Ruolo",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                            
                        },
                        {
                            name: "aggiungiButton",
                            type: "buttonAggiungi",
                            numColMd: 2,
                            label: "Aggiungi",
                            required: false,
                            tooltipText: "",

                            
                        },
                    ]
                }]
            }  
        }
    }
}

export default LineOfInquiryFunzionariStructure;